import {RoleSelectorProps, rolesSelector, useGetAllRolesQuery} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {BaseRoleMultiSelect, BaseRoleMultiSelectProps} from "./BaseRoleMultiSelect";

export type RoleMultiSelectProps = Omit<BaseRoleMultiSelectProps, "entities" | "loading"> & {
  selector?: RoleSelectorProps
}

export const RoleMultiSelect = (props: RoleMultiSelectProps) => {
  const {selector, ...rest} = props;

  const selectRoles = useMemo(() => {
    return rolesSelector();
  }, []);

  const {roles, isLoading} = useGetAllRolesQuery(undefined, {
    selectFromResult: (result) => ({
      roles: selectRoles(result),
      isLoading: result.isLoading
    })
  });

  return <BaseRoleMultiSelect entities={roles} loading={isLoading} {...rest} />;
};
